import styled from 'styled-components';

export const Base = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: 100vh; /* fallback for older browsers */
	height: 100svh; /* small viewport height - excludes dynamic UI */
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.95);
`;

export const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: transparent;
`;

export const Content = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	z-index: 1;
`;

export const ImageContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: transparent;
	overflow: hidden;
	cursor: pointer;
`;

export const Image = styled.img`
	max-width: 100%;
	max-height: 100%;
	object-fit: contain;
	display: block;
	user-select: none;
	-webkit-user-select: none;
	-webkit-touch-callout: none;
`;

export const LoadingOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.8);
`;

export const TopControls = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
	padding: 20px;
	z-index: 10;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent);
`;

export const BottomControls = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	z-index: 10;
	background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
`;

// Control groups for left and right sides
export const ControlGroup = styled.div`
	display: flex;
	flex-direction: row;
	gap: 12px;
`;

export const BaseButton = styled.button<{ disabled?: boolean }>`
	width: 48px;
	height: 48px;
	border-radius: 50%;
	border: none;
	background-color: ${({ theme, disabled }) => (disabled ? theme.gray['100'] : theme.gray['200'])};
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	transition: all 0.2s ease;
	opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

	/* Mobile-specific styles */
	-webkit-tap-highlight-color: transparent;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	touch-action: manipulation;

	/* Mobile touch feedback */
	@media (hover: none) and (pointer: coarse) {
		&:active {
			background-color: ${({ theme, disabled }) =>
				disabled ? theme.gray['100'] : theme.gray['100']};
			transform: ${({ disabled }) => (disabled ? 'none' : 'scale(0.95)')};
		}
	}
`;

export const CenterButton = styled(BaseButton)`
	width: 56px;
	height: 56px;
`;
